import React, { useRef, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { BrandMark, BrandName } from "./Brand";
import { Upload, Trash2, Loader2 } from "lucide-react";

export default function BrandSettings() {
  const { tenantInfo, loadTenant } = useAuth();
  const [busy, setBusy] = useState(false);
  const [hide, setHide] = useState(!!tenantInfo?.hide_mw);
  const [st, setSt] = useState({ logo_style: tenantInfo?.logo_style || "WIDE", logo_fx: tenantInfo?.logo_fx || "2D", show_name: tenantInfo?.show_name !== false });
  const setStyle = async (k, v) => { setSt((o) => ({ ...o, [k]: v })); await api.put("/tenant/brand", { data: { [k]: v } }); reload(); };
  const Opt = ({ k, v, l }) => <button data-testid={`brand-${k}-${v}`} onClick={() => setStyle(k, v)} className={`rounded-lg px-3 py-1.5 text-xs font-semibold ${st[k] === v ? "bg-blue-500/20 text-blue-300 ring-1 ring-blue-500/40" : "bg-slate-800 text-slate-300"}`}>{l}</button>;
  const fileRef = useRef(null);
  const reload = () => loadTenant();
  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", f); await api.post("/tenant/logo", fd); toast.success("LOGO YÜKLENDİ"); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "LOGO YÜKLENEMEDİ"); }
    finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };
  const remove = async () => { await api.delete("/tenant/logo"); toast.success("LOGO KALDIRILDI"); reload(); };
  const toggle = async (v) => { setHide(v); await api.put("/tenant/brand", { data: { hide_mw: v } }); toast.success(v ? "MWCRMPRO YAZISI GİZLENDİ" : "MWCRMPRO YAZISI GÖSTERİLİYOR"); reload(); };
  const preview = { ...tenantInfo, hide_mw: hide, ...st };
  return (
    <div data-testid="brand-settings" className="space-y-5 rounded-xl border border-slate-800 bg-slate-900/60 p-5">
      <div>
        <h2 className="text-lg font-bold text-white">FİRMA LOGOSU VE MARKA</h2>
        <p className="mt-1 text-xs text-slate-400">LOGONUZ MENÜDE, GİRİŞ SAYFANIZDA, TIR YÜKLEME PLANINDA VE A4 ÇIKTISINDA GÖRÜNÜR. KARE VEYA YATAY, ŞEFFAF ARKA PLANLI PNG / SVG EN İYİ SONUCU VERİR (EN FAZLA 2 MB).</p>
      </div>
      <div className="flex flex-wrap items-center gap-6">
        <div data-testid="brand-preview" className="flex min-w-64 items-center gap-3 rounded-xl border border-slate-800 bg-slate-950 px-4 py-3">
          <BrandMark brand={preview} size={44} /><BrandName brand={preview} />
        </div>
        <div className="flex flex-wrap gap-2">
          <input ref={fileRef} data-testid="brand-file" type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
          <Button data-testid="brand-upload" disabled={busy} onClick={() => fileRef.current?.click()} className="bg-blue-600 text-white hover:bg-blue-700">{busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Upload className="mr-1 h-4 w-4" />} LOGO YÜKLE</Button>
          {tenantInfo?.logo_url && <Button data-testid="brand-remove" variant="outline" onClick={remove} className="border-slate-700 bg-slate-800 text-slate-200"><Trash2 className="mr-1 h-4 w-4" /> LOGOYU KALDIR</Button>}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 text-xs text-slate-400">
        <span className="font-semibold">GÖRÜNÜM:</span><Opt k="logo_style" v="WIDE" l="LOGONUN KENDİ HALİ (GENİŞ)" /><Opt k="logo_style" v="SQUARE" l="KARE KUTU" />
        <span className="ml-3 font-semibold">EFEKT:</span><Opt k="logo_fx" v="2D" l="2D DÜZ" /><Opt k="logo_fx" v="3D" l="3D GÖLGELİ" />
        <span className="ml-3 font-semibold">FİRMA ADI:</span><Opt k="show_name" v={true} l="YANINDA YAZSIN" /><Opt k="show_name" v={false} l="SADECE LOGO" />
      </div>
      <label className="flex cursor-pointer items-center gap-3 text-sm text-slate-200">
        <input data-testid="brand-hide-mw" type="checkbox" checked={hide} onChange={(e) => toggle(e.target.checked)} className="h-4 w-4 accent-blue-500" />
        MWCRMPRO YAZISINI GİZLE (SİSTEM TAMAMEN KENDİ MARKANIZLA GÖRÜNÜR)
      </label>
    </div>
  );
}
